/* eslint-disable react/no-unstable-nested-components */
import { useNavigation, useRoute } from '@react-navigation/native';
import * as React from 'react';
import { ScrollView, TextInput } from 'react-native';
import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
import { useSearchCouponQuery } from 'src/common/hooks/useSearchCouponQuery';
import { Container, EmptyState } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';
import { CouponItem } from './components/CouponItem';

const CouponScreen = () => {
  const navigation = useNavigation();
  const { params } = useRoute<any>();
  const { estimation } = useTripInfoState();

  const [searchText, setSearchText] = React.useState('');
  const { data, isError, isFetching, refetch, error } = useSearchCouponQuery(searchText);

  const handleSearchPress = () => {
    // doing searching
    refetch();
  };

  React.useEffect(() => {
    if (searchText.length > 2) {
      refetch();
    }
  }, [searchText]);

  const renderHeader = () => {
    return estimation?.coupons.map(item => (
      <CouponItem
        item={item}
        onPress={coupon => {
          params.onCouponSelected(coupon);
          navigation.goBack();
        }}
      />
    ));
  };

  return (
    <Container flex backgroundColor={AppColors.backgroundColor}>
      <Container backgroundColor={AppColors.primary} padding={metrics.large} paddingTop={0}>
        <TextInput
          style={{
            backgroundColor: AppColors.white,
            height: pixelScaler(40),
            borderRadius: metrics.borderRadius,
            padding: metrics.large,
            ...({
              outlineStyle: 'none',
            } as any),
          }}
          placeholder="Search"
          placeholderTextColor={AppColors.gray}
          returnKeyType="search"
          onSubmitEditing={handleSearchPress}
          value={searchText}
          onChangeText={setSearchText}
        />
      </Container>
      {isFetching || isError ? (
        <EmptyState loading={isFetching} error={error} text="tripEmptyContent" />
      ) : (
        <ScrollView contentContainerStyle={{ padding: metrics.large }}>
          {renderHeader()}
          {data &&
            data.map((item, index) => (
              <CouponItem
                key={index.toString()}
                item={item}
                onPress={coupon => {
                  params.onCouponSelected(coupon);
                  navigation.goBack();
                }}
              />
            ))}
        </ScrollView>
        // <FlatList
        //   contentContainerStyle={{ padding: metrics.large }}
        //   data={data}
        //   ItemSeparatorComponent={() => <SizedBox height="medium" />}
        //   keyExtractor={keyExtractor}
        //   renderItem={({ item }) => (
        //     <CouponItem
        //       item={item}
        //       onPress={coupon => {
        //         params.onCouponSelected(coupon);
        //         navigation.goBack();
        //       }}
        //     />
        //   )}
        // />
      )}
    </Container>
  );
};

export default CouponScreen;
